export default __webpack_public_path__ + "static/media/public_transport.883fa8c2.svg";